module.exports = __webpack_public_path__ + "files/63118a17527998a97fefdbf75156ddfa.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/exo2-bold-webfont.woff
 ** module id = 908
 ** module chunks = 0
 **/